import { WebphoneCallState } from '@modules/SoftPhoneModule/types';
import CallControls from './components/CallControls';
import { useCallBarProps } from './hooks/useCallBarProps';

interface FixedCallBarProps {
  callState: WebphoneCallState;
  show: boolean;
}

export function FixedCallBar({ callState, show }: Readonly<FixedCallBarProps>) {
  const callBarProps = useCallBarProps(callState, show);

  if (!callBarProps) {
    return null;
  }

  return <CallControls pinned {...callBarProps} />;
}
